import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosBreadcrumb } from './breadcrumb'
import { IcosBreadcrumbItem } from './breadcrumb-item'


@NgModule({
  declarations: [IcosBreadcrumb, IcosBreadcrumbItem],
  exports: [IcosBreadcrumb, IcosBreadcrumbItem],
  imports: [CommonModule],
  entryComponents: [IcosBreadcrumb],
})
export class IcosBreadcrumbsModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosBreadcrumbsModule, providers: [] }
  }
}
